module.exports = __webpack_public_path__ + "img/ep-houx.c599a052.jpg";